<template>
  <div>
    <CustomDropdown v-model="showDropdown" :align=" $is_mobile_view ? 'left' : 'right'">
      <template #trigger>
        <div class="px-2-5 py-2 d-flex align-items-center border-form rounded">
          <p class="mb-0 text-subcolor body-2-4">{{ getCurrency.symbol_native }}</p>
      
          <p class="mb-0 body-2-4 mx-2-5 flex-shrink-0"><span class="text-subcolor body-2-1">Budget</span><span class="d-none d-md-inline"> : {{ summaryPrice }}</span></p>
          
          <svg class="delay" :class="{'transform-180' : showDropdown}" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.52769 8C6.7155 8 6.90325 7.92487 7.031 7.78212L12.8451 1.82535C12.9727 1.69765 13.0479 1.53239 13.0479 1.3446C13.0479 0.953987 12.7549 0.653519 12.3643 0.653519C12.1765 0.653519 12.0037 0.728637 11.876 0.848825L6.12205 6.7305H6.92581L1.17182 0.848825C1.05164 0.728637 0.878869 0.653519 0.683569 0.653519C0.292957 0.653519 0 0.953987 0 1.3446C0 1.53239 0.0751175 1.69765 0.202816 1.83286L6.01689 7.78212C6.15961 7.92487 6.33238 8 6.52769 8Z" fill="#999999" />
          </svg>        
        </div>
      </template>

      <template #content>
        <div class="p-3" style="width: 220px">
          <div class="w-100 mb-3" :key="inputWrapperKey">
            <div class="w-100 mb-3">
              <p class="body-3-1 mb-1">Minimum</p>
              <input-currency-v2 v-model="minPrice" />
            </div>
            <div class="w-100 mb-3">
              <p class="body-3-1 mb-1">Maximum</p>
              <input-currency-v2 v-model="maxPrice" />
            </div>
          </div>
          <p v-if="showErrorMaximum" class="mb-2 body-3 text-danger">Maximum price must greater than minimum price</p>
          <div class="w-100 d-flex align-items-center justify-content-end">
            <button v-if="showClearButton" type="button"
              class="button-primary box-shadow-none border-black font-bold bg-white text-dark px-4 py-2 text-12" @click="applyChanges(true)">Clear</button>
            <button type="button" class="button-primary px-4 py-2 text-12 ml-2" @click="applyChanges()">Apply</button>
          </div>
        </div>
      </template>
    </CustomDropdown>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import CustomDropdown from '../../general/CustomDropdown.vue';

  export default {
    components:{
      CustomDropdown
    },
    data(){
      return{
        showDropdown: false,
        minPrice: 0,
        maxPrice: 0,
        showError: false,
        inputWrapperKey: 0
      }
    },
    computed:{
      ...mapGetters(['getBePrice', 'getCurrency']),
      summaryPrice(){
        const start = this.getBePrice[0];
        const end = this.getBePrice[1];
        
        if(start === 0 && end === 0) return 'All Price';

        if(start === 0){
          return `Up to ${this.$formatCurrency(end)}`
        }
        
        if(end === 0){
          return `Start from ${this.$formatCurrency(start)}`
        }

        return `${this.$formatCurrency(start)} - ${this.$formatCurrency(end)}`
      },
      showClearButton(){
        return this.minPrice > 0 || this.minPrice > 0;
      },
      showErrorMaximum(){
        if(!this.showError || this.maxPrice === 0) return false;
        if(this.maxPrice <= this.minPrice) return true;
        return false;
      }
    },
    watch:{
      showDropdown(){
        setTimeout(() => {
          this.minPrice = this.getBePrice[0];
          this.maxPrice = this.getBePrice[1];
          this.showError = false
          this.inputWrapperKey++
        }, 50);
      }
    },
    methods:{
      ...mapMutations(['setBePrice']),
      applyChanges(isClear = false){
        if(!isClear) this.showError = true;
        if(this.showErrorMaximum) return;
        const params = isClear ? [0,0] : [this.minPrice, this.maxPrice]
        this.setBePrice(params);
        this.$emit('apply');
        setTimeout(() => {
          this.showDropdown = false
        }, 50);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/HotelRoomFilterPrice.vue